export const CHAT_ID = "Chat_umGhMcFUKHZR7GdiDXyUW7";
export const BADGE_ID = "Badge_feqghVwfUMZYcG7aSZZfvP";
export const AVATAR_ID = "Avatar_QuqPMEbhuxf4HPM5Yf6cQg";
export const STICKERS_ID = "Stickers_rz29ieSAoyG8eQxN9bqht8";
export const THEME_ID = "Theme_vvQjHh4MUGbbCsATTJtyGE";
